'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res2, _Component);

  function Module2Res2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res2.__proto__ || (0, _getPrototypeOf2.default)(Module2Res2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Creating a healthy home environment'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module2Res2, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, lg: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Things to consider about your family mealtime'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Do you keep fruit and vegetables visibile and ready to eat?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We know this may not be possible, but it is important. Children are more likely to taste new foods or eat their meal when they see other family members eating them too.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If your child does not eat enough fruit, one of the easiest things you can do is wash some fresh fruit, and keep it out on the table.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Do you include fruit and vegetables in lunches and snacks?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Try to provide fruit and vegies at lunch and as snacks. You can put them on a sandwich, chop them up, serve them whole, skewer them, bake them, stew them and so much more.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Do you buy enough fruit and vegetables?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We know it is important to buy fruit and vegies, so why don\'t we always do it? Sometimes it can be difficult because they seem too expensive or heavy to transport, because there is too much wastage from uneaten vegies, or because it can be a pain to take kids shopping.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Do you include vegetables with dinner?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It is important to include a few serves of vegies with your family meal. You might like to have a look through the recipes in the resources section, for simple recipes that are low-cost and full of vegies for ideas you might like to try for your family.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Do you limit non-core or less healthy foods in the home?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most of us have at least some unhealthy food in our home. When kids know that there are non-core foods in the house, it can be difficult to encourage them to eat healthy foods.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To help avoid this problem, try to:'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Buy them when children are not with you'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Unpack them when your children are not watching'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Store them somewhere your children won\'t be able to find them'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Keep them out of your child\'s sight'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Keep them out of your child\'s reach'
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res2.js
// module id = 1239
// module chunks = 0